import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";

export interface ICreateGroupForm {
  name: string;
}

export const createGroupForm: FormBuilderType<ICreateGroupForm> = {
  name: {
    type: "input",
    name: "name",
    label: "",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
    required: true,
    props: {
      keyboardType: "name-phone-pad",
      placeholder: "Team name",
    },
  },
};
